import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

//components
import ManageTableWithDynamicPagination from "../../Components/TableTemplate/ManageTableWithDynamicPagination";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";
import Select from "react-select";
import * as XLSX from "xlsx";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";
import toast from "react-hot-toast";
import { toastStyle, refreshPage, isAdmin, selectDropdownStyle } from "../../Helpers/Utils/Common";
import InputError from "../../Components/InputError/InputError";
import { createTerminal, deleteTerminals, searchTerminal, updateTerminal } from "../../Helpers/apiCalls/Manage/terminals";
import { getAllBranches } from "../../Helpers/apiCalls/Manage/Branches";
import { validateTerminals } from "../../Helpers/Validation/Manage/TerminalsValidation";
import Footer from "../../Components/Footer/Footer";
import downloadIcon from "../../Assets/Images/download_icon.png";

export default function Terminals() {
    const [inactive, setInactive] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
        page: 1,
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    // MODALS //
    // DELETE
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // VIEW
    const [showViewTerminalModal, setShowViewTerminalModal] = useState(false);
    const handleShowViewTerminalModal = () => setShowViewTerminalModal(true);
    const handleCloseViewTerminalModal = () => setShowViewTerminalModal(false);

    // EDIT
    const [showEditTerminalModal, setShowEditTerminalModal] = useState(false);
    const handleShowEditTerminalModal = () => setShowEditTerminalModal(true);
    const handleCloseEditTerminalModal = () => setShowEditTerminalModal(false);

    // ADD
    const [showAddTerminalModal, setShowAddTerminalModal] = useState(false);
    const handleShowAddTerminalModal = () => setShowAddTerminalModal(true);
    const handleCloseAddTerminalModal = () => setShowAddTerminalModal(false);

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        bank_name: false,
        account_name: false,
        account_no: false,
    });

    //API
    const [allData, setAllData] = useState([]);
    const [branches, setBranches] = useState([]);
    const [allBranches, setAllBranches] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});
    const [addDetails, setAddDetails] = useState({
        name: "",
        branch_id: "",
        details: "",
        status: "active",
    });

    const handleAddChange = (e, search) => {
        if (search) {
            setAddDetails((prevState) => ({
                ...prevState,
                [e.var_name]: e.value,
                [e.for]: {
                    label:e.label,
                    value:e.value,
                    name:e.name,
                },
            }));
        } else {
            const { name, value } = e.target;
            setAddDetails((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const xlsxHeaders =  [
        "NAME",
        "BRANCH",
        "DETAILS",
        "STATUS",
    ]

    //EXPORT 
    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "Terminals.xlsx", { compression: true });
    }
    

    //DROPDOWN
    function handleSelectChange(e, row) {
        
        setSelectedRow(row);

        if (e.target.value === "delete-bank") {
            handleShowDeleteModal();
        } else if (e.target.value === "edit-bank") {
            setAddDetails(row);
            handleShowEditTerminalModal();
        } else if (e.target.value === "view-enrollment") {
            handleShowViewTerminalModal();
        } else {
            handleShowDeleteModal();
        }
        setShowLoader(false);
    }

    function ActionBtn(row) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action form-select"
                id={row.id}
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option defaulValue selected hidden>
                    Select
                </option>
                {isAdmin() && (
                    <option value="edit-bank" className="color-options">
                        Edit
                    </option>
                )}
                {isAdmin() && (
                    <option value="delete-bank" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    async function fetchBranches() {
        setBranches([]);
        const response = await getAllBranches();
        if (response.data) {
            var filteredBranches = response.data.data.data.filter((company) => { return company.is_franchise === "0"})
            // var filteredBranches = response.data.data.data
            .map((data) => {
                var branch = data;
                branch.label = data.name;
                branch.value = data.id;
                branch.var_name = "branch_id";
                branch.for = "branch_id_value";
                return branch;
            });
            setBranches(filteredBranches);

            var allBranches = response.data.data.data.filter((company) => { return company.is_franchise === "0"})
            .map((data) => {
                var branch = data;
                branch.label = data.name;
                branch.value = data.id;
                branch.for = "branch_id_value";
                return branch;
            });
            setAllBranches([{ label: "All Branches", value: "" }, ...allBranches]);
        }
    }

    async function handleCreateTerminal() {
        if (validateTerminals(addDetails, setIsError)) {
            setIsClicked(true);
            const response = await createTerminal(addDetails);
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
            setIsClicked(false);
        }
    }

    async function fetchTerminals() {
        setTotalItems(0);
        setAllData([]);
        setExcelData([]);
        setShowLoader(true);
        const response = await searchTerminal(filterConfig);
        if (response.data) {
            let result = response.data.data.data.map((data) => {
                var info = data
                info.branch_id_value = {
                    label: data.branch_name,
                    value: data.branch_id,
                }
                return info
            });
            setAllData(result);
            setTotalItems(response.data.data.size)

            var excel = result.map((data) => {
                var info = {};
                info.name = data.name
                info.branch_name = data.branch_name
                info.details = data.details
                info.status = data.status
                return info;
            });
            setExcelData(excel)
        }
        setShowLoader(false);
    }

    async function handleDeleteTerminal() {
        setIsClicked(true);
        const response = await deleteTerminals(selectedRow.id);
        
        if (response.data) {
            toast.success(response.data.message, {
                style: toastStyle(),
            });
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
        }
        setTimeout(() => refreshPage(), 1000);
    }

    async function handleUpdateTerminal() {
        if (validateTerminals(addDetails, setIsError)) {
            const response = await updateTerminal(addDetails);
            setIsClicked(true);

            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setShowEditTerminalModal(false);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
            setTimeout(() => refreshPage(), 1000);
        }
    }

    useEffect(() => {
        fetchTerminals();
        fetchBranches()
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"MANAGE"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> TERMINALS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            className="search-bar"
                            defaultValue=""
                            name="name"
                            placeholder="Search name..."
                            // onChange={(e) => setSearchBankName(e.target.value)}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                    setFilterConfig((prev) => {
                                        return { ...prev, name: e.target.value };
                                    })
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                        <button
                            className="add-btn"
                            onClick={handleShowAddTerminalModal}
                        >
                            Add
                        </button>
                        </div>
                    </Col>
                </Row>

                {/* TABLE */}
                <div className="tab-content">

                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter px-0 py-0 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={selectDropdownStyle}
                            options={allBranches}
                            onChange={(e) => {
                            setFilterConfig((prev) => {
                                return { ...prev, branch_id: e.value };
                            });
                            }}
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <ManageTableWithDynamicPagination
                        tableHeaders={[
                            "NAME",
                            "BRANCH",
                            "DETAILS",
                            "STATUS",
                            "ACTIONS",
                        ]}
                        headerSelector={[
                            "name",
                            "branch_name",
                            "details",
                            "status",
                        ]}
                        tableData={allData}
                        showLoader={showLoader}
                        ActionBtn={(row) => ActionBtn(row)}
                        // used in dynamic pagination
                        totalItems={totalItems}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        handlePageChange={handlePageChange}
                    />
                </div>
                <div className="mb-3" />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>

            {/* MODALS */}
            <DeleteModal
                text="terminal"
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onDelete={() => handleDeleteTerminal()}
                isClicked={isClicked}
            />
            <AddModal
                title="TERMINAL"
                size="lg"
                type="terminal"
                show={showAddTerminalModal}
                onHide={handleCloseAddTerminalModal}
                onSave={() => handleCreateTerminal()}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col xs={12} lg={6}>
                            NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="name"
                                value={addDetails.name}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.name}
                                message={"Name is required"}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            BRANCH
                            <span className="required-icon">*</span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select branch..."
                                value={addDetails.branch_id_value}
                                options={branches}
                                onChange={(e) => handleAddChange(e, true)}
                            />
                            <InputError
                                isValid={isError.branch_id}
                                message={"Branch is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-2">
                        <Col xs={12} lg={6}>
                            STATUS
                            <span className="required-icon">*</span>
                            <select
                                className="nc-modal-custom-select"
                                name="status"
                                defaultValue={addDetails.status}
                                onChange={(e) => handleAddChange(e)}
                            >
                                <option value="" hidden>
                                Select
                                </option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                                <option value="decommissioned">Decommissioned</option>
                            </select>
                            <InputError
                                isValid={isError.status}
                                message={"Status is required"}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            DETAILS
                            <Form.Control
                                type="text"
                                name="details"
                                value={addDetails.details}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                </div>
            </AddModal>
            <EditModal
                title="TERMINAL"
                size="lg"
                type="terminal"
                show={showEditTerminalModal}
                onHide={handleCloseEditTerminalModal}
                onSave={handleUpdateTerminal}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col xs={12} lg={6}>
                            NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="name"
                                value={addDetails.name}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.name}
                                message={"Name is required"}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            BRANCH
                            <span className="required-icon">*</span>
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                placeholder="Select branch..."
                                value={addDetails.branch_id_value}
                                options={branches}
                                onChange={(e) => handleAddChange(e, true)}
                            />
                            <InputError
                                isValid={isError.branch_id}
                                message={"Branch is required"}
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-2">
                        <Col xs={12} lg={6}>
                            STATUS
                            <span className="required-icon">*</span>
                            <select
                                className="nc-modal-custom-select"
                                name="status"
                                defaultValue={addDetails.status}
                                onChange={(e) => handleAddChange(e)}
                            >
                                <option value="" hidden>
                                Select
                                </option>
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                                <option value="decommissioned">Decommissioned</option>
                            </select>
                            <InputError
                                isValid={isError.status}
                                message={"Status is required"}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            DETAILS
                            <Form.Control
                                type="text"
                                name="details"
                                value={addDetails.details}
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                </div>
            </EditModal>
            <Footer/>
        </div>
    );
}
